export default {
  data() {
    return {
      disableButton: false
    }
  },
  async created() {
    if (this.userProfile && this.userProfile.autoFetch === true) {
      await this.getProfileInfo()
    }
  },
  watch: {
    '$auth.user.profile_form_status': {
      handler(val) {
        if (this.userProfile && this.userProfile.autoFetch === true) {
          this.getProfileInfo()
        }
      }
    }
  },
  methods: {
    submit() {
      if (this.formValues && this.formValues.id) {
        this.updateInfo()
      } else this.addNewInfo()
    },
    async getProfileInfo() {
      this.loading = true
      await this.$axios
        .$get(this.endpoint || this.userProfile.endpoint)
        .then(response => {
          if (Array.isArray(this.userProfile.details)) {
            if (this.userProfile.extraData) {
              const { results, ...data } = response
              this.userProfile.details = results
              this.userProfile.extraData = data
            } else {
              this.userProfile.details = response.results
            }
          } else {
            this.userProfile.details = response
          }
          this.fetchSuccess()
        })
        .finally(() => {
          this.loading = false
        })
    },
    async addNewInfo() {
      if (this.loading) return
      if (await this.validateAllFields()) {
        this.loading = true
        const endpoint = this.endpoint || `${this.userProfile.endpoint}`
        this.$axios
          .$post(endpoint, this.getFormValues())
          .then(response => {
            this.$emit('create')
            this.$emit('closeThis')
            this.$auth.fetchUser()
            this.$emit('saveAndAddAnother')
            this.notifyUser(
              this.createSuccessMessage ||
                `${this.$t('Successfully Created', [this.userProfile.name])}`
            )
          })
          .catch(error => {
            this.getError(error)
            this.showNonFieldErrors(error)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async updateInfo() {
      if (this.loading) return
      if (await this.validateAllFields()) {
        this.loading = true
        const endpoint =
          this.endpoint ||
          `${this.userProfile.endpoint}${this.actionData[this.userProfile.pk]}/`
        const data = this.getFormValues()
        this.$axios({
          method: this.updateRequestType || 'put',
          url: endpoint,
          data
        })
          .then(response => {
            this.$emit('update')
            this.$emit('closeThis')
            this.$emit('errorEmit', (this.disableButton = false))
            this.$auth.fetchUser()
            this.notifyUser(
              `${this.$t('Successfully Updated', [this.userProfile.name])}`
            )
          })
          .catch(error => {
            this.getError(error)
            this.$emit('errorEmit', (this.disableButton = false))
            this.showNonFieldErrors(error)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    deleteInfo() {
      const endpoint = `${this.userProfile.endpoint}${
        this.actionData[this.userProfile.pk]
      }/`
      this.$axios.$delete(endpoint).then(() => {
        this.$auth.fetchUser()
        this.notifyUser(
          `${this.$t('Successfully Deleted', [
            this.userProfile && this.userProfile.name
          ])}`
        )

        this.actionData[this.userProfile.pk] = ''
        this.deleteSuccess()
      })
    },
    deleteSuccess() {
      this.showDeleteModal = false
      this.actionData = {}
      this.getProfileInfo()
    },
    createSuccess() {
      this.showForm = false
      this.actionData = {}
      this.getProfileInfo()
    },
    updateSuccess() {
      this.showForm = false
      this.actionData = {}
      this.getProfileInfo()
    },
    showNonFieldErrors(error) {
      const nonFieldError = JSON.parse(error.response.request.response)
      if (
        nonFieldError.non_field_errors &&
        nonFieldError.non_field_errors.length
      ) {
        this.notifyError(nonFieldError.non_field_errors[0])
      }
    },
    fetchSuccess() {},
    getFormValues() {
      return this.formValues
    }
  }
}
